import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
import { PageErrorBoundary, RouteLoader } from '@appic/ui-components'
import { lazyRoute } from './lazy-route'

const CurriculumPlanning = React.lazy(() => import('@/pages/learning/CurriculumPlanning'))
const LearnerDashboard = React.lazy(() => import('@/pages/learning/LearnerDashboard'))
const AccessibleLearnerDashboard = React.lazy(() => import('@/pages/learning/AccessibleLearnerDashboard'))
const LehrplanPage = React.lazy(() => import('@/pages/learning/LehrplanPage'))

export function renderLearningRoutes(): React.ReactElement {
  return (
    <>
      <Route path="learning/curriculum" element={lazyRoute(CurriculumPlanning, 'Loading curriculum planning...')} />
      <Route path="learning/dashboard" element={lazyRoute(LearnerDashboard, 'Loading learner dashboard...')} />
      <Route path="learning/dashboard/accessible" element={lazyRoute(AccessibleLearnerDashboard, 'Loading accessible learner dashboard...')} />
      <Route path="learning/lehrplan" element={lazyRoute(LehrplanPage, 'Loading Lehrplan...')} />
      <Route path="admin/curriculum" element={
        <PageErrorBoundary>
          <Suspense fallback={<RouteLoader label="Loading curriculum planning..." />}>
            <CurriculumPlanning />
          </Suspense>
        </PageErrorBoundary>
      } />
    </>
  )
}
